import type { HTMLElementChildren } from './types';

import remarkGfm from 'remark-gfm';

export const defaultMarkdownConfig = {
  components: {
    a({ children, href }: { href: string; children: string }) {
      return (
        <a href={href} className="text-tiga-action-default">
          {children.replace(/^https?:\/\//, '')}
        </a>
      );
    },
    h1({ children }: HTMLElementChildren) {
      return <h1 className="text-2xl">{children}</h1>;
    },
    h2({ children }: HTMLElementChildren) {
      return <h2 className="text-xl">{children}</h2>;
    },
    h3({ children }: HTMLElementChildren) {
      return <h3 className="text-lg">{children}</h3>;
    },
    h4({ children }: HTMLElementChildren) {
      return <h4 className="text-md">{children}</h4>;
    },
    hr({ children }: HTMLElementChildren) {
      return (
        <hr className="mx-auto my-4 max-w-40 border-tiga-border-default">
          {children}
        </hr>
      );
    },
    ol({ children }: HTMLElementChildren) {
      return <ol className="ml-4 list-inside list-decimal">{children}</ol>;
    },
    td({ children }: HTMLElementChildren) {
      return <td className="align-top">{children}</td>;
    },
    ul({ children }: HTMLElementChildren) {
      return <ul className="ml-4 list-inside list-disc">{children}</ul>;
    },
  },
  remarkPlugins: [remarkGfm],
};
